import { GET_TEAM_LIST, GET_USER_LIST } from "./query";

export const teamUserData = {
  team: {
    query: GET_TEAM_LIST
  },
  user: {
    query: GET_USER_LIST
  }
}